import { memo } from "react"
import { cx } from "@emotion/css"
import { Atom, PrimitiveAtom } from "jotai"

import { useCellStore } from "./TableScope"
import { useColumn } from "./atoms"
import { useAtomValue } from "jotai/utils"

type CellProps = {
  rowIndex: number
  rowId: string
  columnId: string
}

function _Cell(props: CellProps) {
  const { rowIndex, rowId, columnId } = props
  const cells = useCellStore()

  const atom = cells.getCell(rowId, columnId)
  const column = useColumn(columnId)

  let render = null
  if (!column) {
    render = <span>&nbsp;</span>
  } else if (!column.cell || !column.cell.render) {
    render = <DefaultRender atom={atom} />
  } else {
    if (column.cell.type === "display") {
      let C = column.cell.render
      render = <C rowId={rowId} rowIndex={rowIndex} columnId={columnId} />
    } else if (column.cell.type === "writable") {
      let C = column.cell.render
      render = (
        <C
          rowId={rowId}
          rowIndex={rowIndex}
          columnId={columnId}
          atom={atom as PrimitiveAtom<any>}
        />
      )
    } else if (column.cell.type === "derived") {
      let C = column.cell.render
      render = (
        <C rowId={rowId} rowIndex={rowIndex} columnId={columnId} atom={atom} />
      )
    }
  }

  return (
    <td
      role="cell"
      className={cx(column?.align)}
      style={{ width: column?.width }}
    >
      {render}
    </td>
  )
}

function DefaultRender(props: { atom: Atom<any> }) {
  const cells = useCellStore()
  const value = useAtomValue(props.atom)
  if (cells.isEmpty(value)) {
    return <span>&nbsp;</span>
  }
  return <span>{value}</span>
}

export const Cell = memo(_Cell)
